module.exports = {
    COMMUNITY_CHAT: "COMMUNITY_CHAT",
    USER_CONNECTED: "USER_CONNECTED",
    MESSAGE_RECIEVED: "MESSAGE_RECIEVED",
    MESSAGE_SENT: "MESSAGE_SENT",
    USER_DISCONNECTED: "USER_DISCONNECTED",
    TYPING: "TYPING",
    VERIFY_USER: "VERIFY_USER",
    LOGOUT: "LOGOUT",
    PRIVATE_MESSAGE: "PRIVATE_MESSAGE",
    NEW_CHAT_USER: 'NEW_CHAT_USER'
}